module.exports = __webpack_public_path__ + "img/20200427144539TIM截图20200427143058.faef6054.png";